/* eslint-disable max-len,import/prefer-default-export */

const loadThemeColorsStyles = async () => import(
  /* webpackChunkName: "theme-colors-styles" */
  '../../theme-colors.css'
);

const loadDateRangePickerStyles = async () => {
  await import(
    /* webpackChunkName: "date-range-picker-core-styles" */
    'react-day-picker/dist/style.css'
  );
  await import(
    /* webpackChunkName: "date-range-picker-overrides-styles" */
    '../../components/DateRangePicker/date-range-picker-overrides.css'
  );
};

const loadSnackbarStyles = async () => {
  await import(
    /* webpackChunkName: "snackbar-styles" */
    'react-toastify/dist/ReactToastify.css'
  );
  await import(
    /* webpackChunkName: "snackbar-overrides-styles" */
    '../../components/Snackbar/snackbar-overrides.css'
  );
};

// used in SecurityScoreWidget
const loadReactCircularProgressbarStyles = async () => import(
  /* webpackChunkName: "react-circular-progressbar-styles" */
  'react-circular-progressbar/dist/styles.css'
);

const loadCustomScrollbarStyles = async () => {
  await import(
    /* webpackChunkName: "overlayscrollbars-styles" */
    // eslint-disable-next-line import/no-unresolved
    'overlayscrollbars/overlayscrollbars.css'
  );
  await import(
    /* webpackChunkName: "scrollbar-overrides-styles" */
    '../customScrollbar/scrollbar-overrides.css'
  );
};

/**
 * @types.themeColors use to load some of the Uniqkey theme colors;
 *  required for 'DateRangePicker' and 'customScrollbar'
 * @types.dateRangePicker use to load 'DateRangePicker' styles; requires 'themeColors' to be loaded as well
 * @types.snackbar use to load Snackbar styles (showSuccess, showError, etc.)
 * @types.reactCircularProgressbar use to load ReactCircularProgressbar styles; used for 'SecurityScoreWidget'
 * @types.customScrollbar use to load OverlayScrollbars styles; used for custom scrollbar
 * */
interface ILoadStylesTypes {
  themeColors?: boolean;
  dateRangePicker?: boolean;
  snackbar?: boolean;
  reactCircularProgressbar?: boolean;
  customScrollbar?: boolean;
}

export const loadStyles = (types: ILoadStylesTypes) => {
  const {
    themeColors = false,
    dateRangePicker = false,
    snackbar = false,
    reactCircularProgressbar = false,
    customScrollbar = false,
  } = types;
  const promises = [];
  if (themeColors) {
    promises.push(loadThemeColorsStyles());
  }
  if (dateRangePicker) {
    if (!themeColors) {
      throw new Error(
        'DateRangePicker styles require \'theme-colors.css\'.\n'
        + 'Set "themeColors: true" to load \'theme-colors.css\'.',
      );
    }
    promises.push(loadDateRangePickerStyles());
  }
  if (snackbar) {
    promises.push(loadSnackbarStyles());
  }
  if (reactCircularProgressbar) {
    promises.push(loadReactCircularProgressbarStyles());
  }
  if (customScrollbar) {
    promises.push(loadCustomScrollbarStyles());
  }
  return Promise.all(promises);
};
